"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileExtension = void 0;
class FileExtension {
    constructor(value) {
        this.Value = (value.startsWith(".") ? value : "." + value).toUpperCase();
    }
    toString() {
        return this.Value;
    }
    Matches(path) {
        return path.toUpperCase().endsWith(this.Value);
    }
    /** Removes this extension from the given path, if present. */
    RemoveFrom(path) {
        return this.Matches(path)
            ? path.slice(0, -this.Value.length)
            : path;
    }
}
exports.FileExtension = FileExtension;
//# sourceMappingURL=file-extension.js.map